// extracted by mini-css-extract-plugin
module.exports = {"navIcon":"hamburgerIcon_navIcon__3BEVJ","active":"hamburgerIcon_active__2r_Av"};